import { createFileRoute } from "@tanstack/react-router";
import AddictionTreatmentCamdenNJ from "@/pages/AddictionTreatmentCamdenNJ";
import { routeHead } from "@/lib/route-head";

export const Route = createFileRoute("/addiction-treatment-camden-nj")({
  head: () => routeHead("/addiction-treatment-camden-nj"),
  component: AddictionTreatmentCamdenNJ,
});
